import { assign } from 'lodash'

export default function(task) {
  return assign({}, task, {
    uid: `${task.source}-${task.id || task.goalId}`,
    completedAt: task.completedAt ? new Date(task.completedAt) : undefined,
    dueAt: task.dueAt ? new Date(task.dueAt) : undefined,
    createdAt: task.createdAt ? new Date(task.createdAt) : undefined,
  })
}


// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/tasks/shared/parseTask.js